<div class="game-dashboard-block organization-trophies-block" brtBorderGradient>
  <div class="organization-trophies-block__headline">
    <brt-dashboard-boxes-head [data]="headlineBlockData"></brt-dashboard-boxes-head>
  </div>

  <div class="organization-trophies-block__content">
    <div class="organization-trophies-block__items">
      <brt-trophies-list [items]="organizationTrophies.items"></brt-trophies-list>
    </div>

    <div class="organization-trophies-block__footer">
      <brt-button [color]="'white'" [size]="'small'" [title]="'CLASS_DASHBOARD.SHOW_ALL_TROPHIES' | translate" (click)="openFullList();"></brt-button>
    </div>
  </div>
</div>
